import { actionTypes } from './actions';

export const initialState = {
  accessToken: null,
  verifying: false,
  user: {},
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.VERIFY_TOKEN:
      return { ...state, verifying: true };

    case actionTypes.VERIFY_TOKEN_SUCCESS: {
      const { accessToken, user } = action;
      return {
        ...state,
        verifying: false,
        accessToken,
        user,
      };
    }

    case actionTypes.VERIFY_TOKEN_FAILURE:
      return { ...state, verifying: false };

    case actionTypes.UPDATE_USER_INFO: {
      const { user } = action;
      return { ...state, user: { ...state.user, ...user } };
    }

    case actionTypes.UPDATE_BONUS_CHARACTERS: {
      const { bonusCharacters } = action;
      return { ...state, user: { ...state.user, bonusCharacters } };
    }

    case actionTypes.REGISTER_REFERRAL: {
      const { systemReferralCode, joinedAt } = action.payload;
      return {
        ...state,
        user: {
          ...state.user,
          referral: { ...state.user.referral, systemReferralCode, joinedAt },
        },
      };
    }

    case actionTypes.UPDATE_REFERRER_ID: {
      const { referrerId } = action;
      return {
        ...state,
        user: {
          ...state.user,
          referral: { ...state.user.referral, referrerId },
        },
      };
    }

    case actionTypes.UPDATE_REFERRAL_CODE: {
      const { referralCode } = action;
      return {
        ...state,
        user: {
          ...state.user,
          referral: { ...state.user.referral, referralCode },
        },
      };
    }

    case actionTypes.UPDATE_REFERRAL_STATS: {
      const { earnedPoints, spentPoints, referralSuccessCount } =
        action.payload;
      return {
        ...state,
        user: {
          ...state.user,
          referral: {
            ...state.user.referral,
            earnedPoints,
            spentPoints,
            referralSuccessCount,
          },
        },
      };
    }

    case actionTypes.UPDATE_REFERRAL_REVENUE: {
      const { totalRevenue, refereeFirstPaidOrderCount } = action.payload;
      return {
        ...state,
        user: {
          ...state.user,
          referral: {
            ...state.user.referral,
            totalRevenue,
            refereeFirstPaidOrderCount,
          },
        },
      };
    }

    default:
      return state;
  }
};

export default authReducer;
